/*
 * Layout  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { LayoutColumn } from "./LayoutColumn";
import { LayoutPanel } from "./LayoutPanel";
import { LayoutRow } from "./LayoutRow";
import {
	LayoutState_Column,
	LayoutState_Panel,
	LayoutState_Row,
	LayoutState_Splitter,
	LayoutState_Tabs,
	TLayoutState
} from "./LayoutState";
import { LayoutTabs } from "./LayoutTabs";
import { LAYOUT_TYPE, TLayoutActivateHandler, TLayoutRenderComponentFn } from "./LayoutTypes";
import { LayoutSplitter } from "./LayoutSplitter";

export function renderLayoutElement(
	state: TLayoutState,
	renderComponent: TLayoutRenderComponentFn,
	onActivate: TLayoutActivateHandler
): JSX.Element {
	switch (state.type) {
		case LAYOUT_TYPE.ROW:
			return (
				<LayoutRow
					key={state.id}
					state={state as LayoutState_Row}
					renderComponent={renderComponent}
					onActivate={onActivate}
				/>
			);
		case LAYOUT_TYPE.COLUMN:
			return (
				<LayoutColumn
					key={state.id}
					state={state as LayoutState_Column}
					renderComponent={renderComponent}
					onActivate={onActivate}
				/>
			);
		case LAYOUT_TYPE.PANEL:
			return (
				<LayoutPanel
					key={state.id}
					state={state as LayoutState_Panel}
					renderComponent={renderComponent}
					onActivate={onActivate}
				/>
			);
		case LAYOUT_TYPE.SPLITTER:
			return <LayoutSplitter key={state.id} state={state as LayoutState_Splitter} />;
		case LAYOUT_TYPE.TABS:
			return (
				<LayoutTabs
					key={state.id}
					state={state as LayoutState_Tabs}
					renderComponent={renderComponent}
					onActivate={onActivate}
				/>
			);
	}
}
